const SECRETS = {
    REACT_APP_API_BASE: 'https://tatva-ai-backend.mytatva.in/',
    REACT_APP_WEBSOCKET_BASE: 'wss://tatva-ai-backend.mytatva.in/',
    REACT_APP_MO_ENGAGE_APP_ID: 'TC5B48PR9UEHLG70GXX63D8S',
    REACT_APP_MO_ENGAGE_DATA_CENTER: 'DC_3',
    REACT_APP_MO_ENGAGE_ENABLE_DEBUG_LOGS: 0,
    REACT_APP_BHASHINI_USERID: 'BHASHINI_USERID',
    REACT_APP_BHASHINI_ULCA_APIKEY: 'BHASHINI_ULCA_APIKEY',
    REACT_APP_BHASHINI_APIKEY: 'BHASHINI_APIKEY',
};

export default SECRETS;